module.exports = __webpack_public_path__ + "headshot-ian-spencer.1e8b37.png";